import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import SvgIcon from '../../../svg-icon';

function DocumentTitle({ document, selected, onChange }) {
  const { t } = useTranslation('components');
  function handleTileClick() {
    onChange(document.key);
  }

  const classNames = classnames('document-tile', {
    active: selected,
    [document.key]: true
  });

  return (
    <div className={classNames} onClick={handleTileClick} role="button">
      <div className="document-tile-inner">
        {document.icon && (
          <div className="vertical-center">
            <SvgIcon
              icon={document.icon}
              alt={`${document.key}_icon`}
              themed
              active
              styling="primary"
            />
          </div>
        )}
        <div className="vertical-center text">
          <span className={`document-tile-text ${document.icon ? '' : 'icon'}`}>
            {t(document.text)}
          </span>
        </div>
      </div>
    </div>
  );
}

DocumentTitle.propTypes = {
  document: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.any.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default React.memo(DocumentTitle);
